import { useEffect, useSyncExternalStore } from 'react';

/**
 * A page that knows its own name better than its address does (the 404 and 403, which
 * live on any path) sets the shell's top bar title with usePageTitle. The shell reads it
 * with usePageTitleOverride; null means "use the route's name".
 */
let current: string | null = null;
const listeners = new Set<() => void>();

function set(title: string | null) {
  current = title;
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function usePageTitle(title: string) {
  useEffect(() => {
    set(title);
    return () => set(null);
  }, [title]);
}

export function usePageTitleOverride(): string | null {
  return useSyncExternalStore(subscribe, () => current, () => null);
}
